export const API_URLS = {
  '7.1': 'https://v71.plataforma.brasil.mapbiomas.org/api/graphql',
  '8.0': 'https://v8.plataforma.brasil.mapbiomas.org/api/graphql'
};
